import React, { HTMLAttributes } from 'react';

import { cn } from '@/src/util/ui';

interface ShadowedCardProps extends HTMLAttributes<HTMLDivElement> {
  // Add any additional props
}

const ShadowedCard = ({ children, ...props }: ShadowedCardProps) => {
  return (
    <React.Fragment>
      <div
        {...props}
        className={cn(props.className)}
        style={{
          ...props.style,
          WebkitBoxShadow: '1px 0px 20px 0px rgba(0,0,0,0.05)',
          MozBoxShadow: '1px 0px 20px 0px rgba(0,0,0,0.05)',
          boxShadow: '1px 0px 20px 0px rgba(0,0,0,0.05)',
          clipPath: 'inset(0px -20px 0px 0px)',
        }}
      >
        {children}
      </div>
    </React.Fragment>
  );
};

export default ShadowedCard;
